module.exports = __webpack_public_path__ + "img/messenger-logo-16x16.7bba2753.svg";